import React from "react";

export const SeparatorBlock = () => {
  return (
    <div className="h-px w-full bg-gradient-to-r from-neon-blue via-neon-purple to-neon-green" />
  );
};
